import { useTheme } from "@/lib/theme";

// Primary NOXN wordmark. variant: "white" (dark surfaces), "navy" (light surfaces),
// or "auto" (follows the active theme — use inside ThemedApp areas only).
export const NoxnLogo = ({ variant = "auto", className = "h-6 w-auto", ...rest }) => {
    const { theme } = useTheme();
    const v = variant === "auto" ? (theme === "light" ? "navy" : "white") : variant;
    return (
        <img
            src={`/brand/noxn-logo-${v}.png`}
            alt="NOXN"
            draggable="false"
            className={`select-none ${className}`}
            {...rest}
        />
    );
};
